import { render } from "./DialogModal.vue?vue&type=template&id=64b1799a&ts=true"
import script from "./DialogModal.vue?vue&type=script&lang=ts"
export * from "./DialogModal.vue?vue&type=script&lang=ts"

import "./DialogModal.vue?vue&type=style&index=0&id=64b1799a&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__